// Header search-as-you-type: desktop dropdown (inside .header__search-wrap)
// and the mobile full-screen modal (.header__search-modal) both use the same
// [data-search-input] / [data-search-panel] contract and the same AJAX
// endpoint (fc_search_suggest, see includes/ajax.php + render-search-panel.php)
// — the panel HTML that comes back is byte-for-byte what PHP already
// rendered server-side for the empty-query state, so there's no separate
// client-side templating to keep in sync.

function ajaxUrl() {
    return (window.settings && window.settings.admin_ajax_url) || '/wp-admin/admin-ajax.php';
}

function nonce() {
    return (window.settings && window.settings.cart_nonce) || '';
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
    };
}

function fetchPanel(panel, q) {
    const body = new URLSearchParams({ action: 'fc_search_suggest', nonce: nonce(), q });
    return fetch(ajaxUrl(), { method: 'POST', body, credentials: 'same-origin' })
        .then((r) => r.json())
        .then((res) => {
            if (res && res.success) panel.innerHTML = res.data.html;
        });
}

function init() {
    const inputs = document.querySelectorAll('[data-search-input]');
    if (!inputs.length) return;

    inputs.forEach((input) => {
        const wrap = input.closest('.header__search-wrap, .header__search-modal');
        if (!wrap) return;
        const panel = wrap.querySelector('[data-search-panel]');
        if (!panel) return;

        const runSearch = debounce(() => fetchPanel(panel, input.value.trim()), 250);

        const open = () => wrap.classList.add('header__search-wrap--active');
        const close = () => wrap.classList.remove('header__search-wrap--active');

        input.addEventListener('focus', () => { open(); });
        input.addEventListener('input', () => { open(); runSearch(); });

        // Delegated: the panel's pill buttons are replaced on every fetch.
        panel.addEventListener('click', (e) => {
            const pill = e.target.closest('[data-search-pill]');
            if (!pill) return;
            e.preventDefault();
            input.value = pill.textContent.trim();
            input.focus();
            fetchPanel(panel, input.value);
        });

        // Desktop dropdown only — the mobile modal has its own open/close
        // wiring in header.js (data-header-search-open/-close).
        if (wrap.classList.contains('header__search-wrap')) {
            document.addEventListener('click', (e) => {
                if (!wrap.contains(e.target)) close();
            });
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') close();
            });
        }
    });
}

export default { init };
